export const ROLE = {
  CANDIDATE: "CANDIDATE",
  CARE_HOME: "CARE_HOME",
  ADMIN: "ADMIN"
};
